import React from 'react';
import { useTranslate } from 'app/translations';
import { selfKey } from 'utilities/names';

const Style = {
    container: 'flex flex-wrap w-full',
};

export const Created = ({ isSelf }) => {
    const { _t } = useTranslate();
    return (
        <div className={Style.container}>
            <span>
                {_t(selfKey('ticket.history.event.ticket.created', isSelf)).toLowerCase()}
            </span>
        </div>
    );
};
